import React, { useEffect, useState } from 'react';
import { withStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {Slider, Typography} from '@material-ui/core';
import { iposService, Throttle } from 'app/services/ipos.service';  
import { defaultNumRequests, defaultRequestInterval } from '../../_helpers';
import { useSelector } from "react-redux";
import { RootState } from "app/main/rootReducer";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        width: 800,
        marginTop: 20
    },
    input: {
        width: 42
    }, 
    slider: {
        display: 'flex',
        width: 800,
        padding: theme.spacing(5), 
    },
    sliderHeader: {
        display: 'flex'
    }

}));

const marks = [
    {
        value: 1,
        label: '1'
    },
    {
        value: 5,
        label: '5'
    },
    {
        value: 10,
        label: '10'
    },
];
  
async function GetThrottleNumRequests(venueId: number) : Promise<Throttle> {  
    return await iposService.GetThrottle(venueId); 
}

async function SetThrottleNumRequest(venueId: number, numRequest: number) { 
    return await iposService.SetThrottle(venueId, numRequest);
}

const boxShaddow =
    '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';


const CustomSlider = withStyles({
    root: {
        color: '#3880ff',
        height: 2,
        padding: '15px 0',
    },
    thumb: {
        height: 28,
        width: 28,
        backgroundColor: '#fff',
        boxShadow: boxShaddow,
        marginTop: -14,
        marginLeft: -14,
        '&:focus, &:hover, &$active': {
            boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
            '@media (hover: none)': {
                boxShadow: boxShaddow,
            },
        },
    },
    active: {},
    valueLabel: {
        left: 'calc(-50% + 12px)',
        top: -22,
        '& *': {
            background: 'transparent',
            color: '#000',
        },
    },
    track: {
        height: 2,
    },
    rail: {
        height: 2,
        opacity: 0.5,
        backgroundColor: '#bfbfbf',
    },
    mark: {
        backgroundColor: '#bfbfbf',
        height: 5,
        width: 1,
        marginTop: -5,
    },
    markActive: {
        opacity: 1,
        backgroundColor: 'currentColor',
    },
})(Slider); 

export default function ThrottleComponent() {

    const { selectedVenue } = useSelector((state: RootState) => state.venueReducer);
    const classes = useStyles();
    const [numRequests, setNumRequests] = useState(defaultNumRequests); 

    const handleChangeCommitted = async (event: object, numRequests: number | number[]): Promise<void> => {
        if (typeof (numRequests) === 'number') {
            await SetThrottleNumRequest(selectedVenue.id, numRequests);
            setNumRequests(numRequests);
            console.log(`${numRequests} saved`);
        }
    }; 

    useEffect(() => { 
        async function execAsync() {
            
            let throttle = await GetThrottleNumRequests(selectedVenue.id);
            setNumRequests(throttle.numRequests);
        }

     execAsync(); 

    }, [])

    return (
        <div className={classes.root}> 
            <Typography id="discrete-slider" gutterBottom >
                Requests / {defaultRequestInterval} (ms)
             </Typography> 
            <CustomSlider aria-label="throttle slider"
                key={`slider-${numRequests}`}
                defaultValue={numRequests}
                marks={marks}
                valueLabelDisplay="on"
                onChangeCommitted={handleChangeCommitted}
                min={1}
                max={10}
                step={1}
            />  
        </div>
    );
}